/**
 * Stable action ids map to in-app handlers so persisted inbox rows never store functions (spec §5–7).
 * Register handlers at module init for intents you want clickable from the inbox/snackbar.
 */

/** @type {Map<string, (ctx: { itemId: string }) => void>} */
const _handlers = new Map();

/**
 * @param {string} actionId
 * @param {(ctx: { itemId: string }) => void} handler
 */
export function registerInboxNotificationAction(actionId, handler) {
  if (typeof actionId !== "string" || typeof handler !== "function") return;
  _handlers.set(actionId, handler);
}

/**
 * @param {string} actionId
 * @param {{ itemId: string }} ctx
 */
export function dispatchInboxNotificationAction(actionId, ctx) {
  const fn = _handlers.get(actionId);
  if (!fn) return;
  try {
    fn(ctx);
  } catch (e) {
    console.error("[notificationActionRegistry]", actionId, e);
  }
}

/**
 * @param {string} actionId
 * @returns {boolean}
 */
export function hasInboxNotificationAction(actionId) {
  return _handlers.has(actionId);
}
